import { useLocale } from 'next-intl';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { Option } from 'types/Option';
import { TGenericError } from 'types/TGenericError';
import countryUtil from 'utils/countryUtil';

type TData = Option[];

const useCountry = (
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const locale = useLocale();

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['country', locale],
    queryFn: async () => countryUtil(locale)
  });
};

export default useCountry;
